import { API } from 'aws-amplify';

export interface UpdateTestInventoryInput {
  originalTitle: string;
  title: string;
  grade: number;
  subject: string;
  legacy: boolean;
  test_order: number;
  assignable: boolean;
  language: string;
  levelupdown: boolean;
}

export async function updateTestInventory(
  input: UpdateTestInventoryInput
): Promise<{ result: boolean }> {
  const apiName = process.env.NEXT_PUBLIC_ACADEMICS_API_NAME!;
  const path = 'api/testing/test-inventory';
  const myInit = {
    body: input,
    headers: {},
  };
  return await API.put(apiName, path, myInit);
}
